import type { MockRequest, MockResponse } from "@/mocks/router";
import { store } from "@/mocks/store";
import { ok, paginate } from "./_utils";

export function handleAnalytics(req: MockRequest): MockResponse | null {
  const method = req.method.toUpperCase();
  const path = req.path.replace(/\/+$/, "") || "/";
  const { query, body } = req;

  if (method === "GET" && path === "/api/share-records") {
    let items = [...store.SHARE_RECORDS];
    const channel = query.get("channel");
    const status = query.get("status");
    const ref = query.get("refCode");
    if (channel) items = items.filter((r) => r.channel === channel);
    if (status) items = items.filter((r) => r.status === status);
    if (ref) items = items.filter((r) => r.refCode.includes(ref));
    return ok(paginate(items, query));
  }

  if (method === "GET" && path === "/api/analytics/overview") {
    return ok({
      data: {
        funnel: store.FUNNEL_DATA,
        trends: store.TREND_DATA,
        channels: store.CHANNEL_COMPARE,
        notifications: store.NOTIFICATIONS,
        games: store.GAMES.filter((g) => g.status === "active"),
        packages: store.PACKAGES,
      },
    });
  }
  if (method === "GET" && path === "/api/analytics/funnel") return ok({ data: { levels: store.FUNNEL_LEVELS, data: store.FUNNEL_DATA } });
  if (method === "GET" && path === "/api/analytics/channels") return ok({ data: store.CHANNEL_COMPARE });
  if (method === "GET" && path === "/api/analytics/trends") return ok({ data: store.TREND_DATA });
  if (method === "GET" && path === "/api/analytics/paths") return ok({ data: store.USER_PATH_EXAMPLE });
  if (method === "GET" && path === "/api/analytics/ltv") return ok({ data: { message: "本期提供示意图，不提供在线 LTV 计算", schemes: ["scheme1", "scheme2"] } });
  if (method === "GET" && path === "/api/analytics/retention") return ok({ data: store.CHANNEL_COMPARE.map((c) => ({ channel: c.code, ...c.retention })) });
  if (method === "GET" && path === "/api/analytics/share-details") return ok(paginate(store.SHARE_RECORDS, query));
  if (method === "POST" && path === "/api/analytics/export") {
    return ok({ data: { jobId: `exp_${Date.now()}`, status: "queued", format: (body as { format?: string })?.format || "csv" } }, 202);
  }

  return null;
}
